import React, { Component } from "react";
import { ButtonToolbar, DropdownButton, MenuItem } from "react-bootstrap";

export default class DropdownMenuSurveyHoursOfSleep extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var title = this.props.title;
        return (
            <div>
                <DropdownButton
                  bsSize    = "large"
                  title     = { title }
                  id        = "dropdown-size-large"
                  className = "dropdownWeekCaret"
                  style = {{backgroundColor: "#fff"}}
                  onSelect={(eventKey) => this.props.handle(eventKey)}
                >
                    <MenuItem eventKey="1">1</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="2">2</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="3">3</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="4">4</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="5">5</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="6">6</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="7">7</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="8">8</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="9">9</MenuItem>
                    <MenuItem divider />
                    <MenuItem eventKey="10">10+</MenuItem>
                </DropdownButton>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/DropdownMenuSurveyHoursOfSleep.js